import React from "react";
import { Search, Handshake, Zap, Shield, Award, Users } from "lucide-react";
import "./Capabilities.css";

const capabilities = [
  {
    icon: <Search size={32} />,
    title: "Market Research",
    description: "Deep analysis of African markets and emerging opportunities",
  },
  {
    icon: <Handshake size={32} />,
    title: "Negotiation",
    description: "Expert deal structuring and stakeholder alignment",
  },
  {
    icon: <Zap size={32} />,
    title: "Efficiency",
    description: "Streamlined processes that deliver results faster",
  },
  {
    icon: <Shield size={32} />,
    title: "Integrity",
    description: "Unwavering ethical standards in every transaction",
  },
  {
    icon: <Award size={32} />,
    title: "Excellence",
    description: "World-class service that exceeds expectations",
  },
  {
    icon: <Users size={32} />,
    title: "Partnership",
    description: "Collaborative approach focused on mutual success",
  },
];

function Capabilities() {
  return (
    <section className="capabilities-section">
      <div className="capabilities-container">
        <h2 className="section-title">
          Core <span className="the-color">Capabilities & Values</span>
        </h2>

        <p className="section-subtitle">
          The foundation of our success lies in our distinctive approach and unwavering values
        </p>
        <br/>

        <div className="capabilities-grid">
          {capabilities.map((item, index) => (
            <div key={index} className="capability-card">
              <div className="icon-wrapper2">{item.icon}</div>
              <h3 className="capability-title">{item.title}</h3>
              <p className="capability-desc">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

  );
}

export default Capabilities;